import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';
import './AppHeader.scss'
import {Layout, Menu, Dropdown} from 'antd';
import { HomeOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';

class AppHeader extends Component {
    constructor(props) {
        super(props)
        this.handleMenuClick = this.handleMenuClick.bind(this)
    }

    handleMenuClick({key}) {
        if (key === 'logout') {
            this.props.onLogout()
        }
    }

    render() {
        const { isAuthenticated, currentUser } = this.props;

        let menuItems
        if (this.props.currentUser) {
            menuItems = [
                <Menu.Item key='/'>
                    <Link to='/'>
                        Home
                    </Link>
                </Menu.Item>,
            
                <Menu.Item key='/chiti/note'>
                    <Link to='/chiti/note'>
                        Note
                    </Link>
                </Menu.Item>,
                <Menu.Item key='/profile' className='profile-menu'>
                    <ProfileDropdownMenu
                        currentUser={this.props.currentUser}
                        handleMenuClick={this.handleMenuClick}
                    />
                </Menu.Item>
            ]
        } else {
            menuItems = [
                <Menu.Item key='/'>
                    <Link to='/'><HomeOutlined className='nav-icon' /></Link>
                </Menu.Item>,
                <Menu.Item key='/login'>
                    <Link to='/login'>Login</Link>
                </Menu.Item>,
                <Menu.Item key='/signup'>
                    <Link to='/signup'>Sign Up</Link>
                </Menu.Item>
            ]
        }

        return (
            <Layout.Header className="app-header">
                <div className="app-header-inner">
                    <div className="app-logo">
                        <Link to="/">Chiti</Link>
                    </div>

                    <div className="app-nav">
                        <Menu
                            className='app-menu'
                            mode='horizontal'
                            selectedKeys={[this.props.location.pathname]}
                            style={{lineHeight: '64px'}}
                        >
                            {menuItems}
                        </Menu>
                    </div>
                </div>
            </Layout.Header>
        );
    }
}

function ProfileDropdownMenu(props) {
    const dropdownMenu = (
        <Menu onClick={props.handleMenuClick} className='profile-dropdown-menu'>
            <Menu.Item key='user-info' className='dropdown-item' disabled>
                <div className='user-full-name-info'>{props.currentUser.name}</div>
                <div className='username-info'>@{props.currentUser.username}</div>
            </Menu.Item>
            <Menu.Divider/>
            <Menu.Item key='profile' className='dropdown-item'>
                <Link to={`/users/${props.currentUser.username}`}>Profile</Link>
            </Menu.Item>
            <Menu.Item key='logout' className='dropdown-item'>
                Logout
            </Menu.Item>
        </Menu>
    )

    return (
        <Dropdown
            overlay={dropdownMenu}
            trigger={['click']}
            getPopupContainer={() =>
                document.getElementsByClassName('profile-menu')[0]
            }
        >
            <a className='ant-dropdown-link'>
                <UserOutlined className='nav-icon' style={{marginRight: 0}}/> {' '}
                <DownOutlined />
            </a>
        </Dropdown>
    )
}

export default withRouter(AppHeader)
